module.exports = __webpack_public_path__ + "static/media/logo-2017.1ed15177.png";